var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group-wrapper" }, [
    _c(
      "section",
      { attrs: { role: "contentinfo", "aria-label": _vm.$t(_vm.title) } },
      [
        _c(
          "div",
          { staticClass: "heading-div" },
          [
            _c("header-control", {
              attrs: { title: _vm.title, doNotUseResources: false }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "group-content mt-3 mb-3" },
          [
            _c(
              "div",
              { staticClass: "row form-group" },
              [
                _vm.title
                  ? _c("label-control", {
                      staticClass: "col-12 col-sm-3 col-form-label",
                      attrs: {
                        title: "Organisation.Contacts.FirstName",
                        required: _vm.required,
                        forElement: _vm.title + "_firstname"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-9" }, [
                  _c(
                    "div",
                    { staticClass: "contact" },
                    [
                      _c("ValidationProvider", {
                        attrs: {
                          rules: {
                            required: _vm.required,
                            name: true,
                            maxlength: _vm.nameMaxLength
                          },
                          slim: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.item.firstName,
                                      expression: "item.firstName"
                                    }
                                  ],
                                  class: [
                                    "form-control",
                                    _vm.getValidationErrorClasses(errors)
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: _vm.title + "_firstname",
                                    placeholder: _vm.firstNamePlaceholderString,
                                    readOnly: _vm.isReadOnly,
                                    disabled: _vm.isReadOnly,
                                    maxlength: _vm.nameMaxLength,
                                    "aria-required":
                                      _vm.required && !_vm.isReadOnly,
                                    "aria-invalid":
                                      _vm.required &&
                                      !_vm.isReadOnly &&
                                      errors.length > 0
                                  },
                                  domProps: { value: _vm.item.firstName },
                                  on: {
                                    focus: function($event) {
                                      return _vm.touch()
                                    },
                                    blur: function($event) {
                                      return _vm.onBlur()
                                    },
                                    change: function($event) {
                                      return _vm.change()
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.item,
                                        "firstName",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row form-group" },
              [
                _c("label-control", {
                  staticClass: "col-12 col-sm-3 col-form-label",
                  attrs: {
                    title: "Organisation.Contacts.LastName",
                    required: _vm.required,
                    forElement: _vm.title + "_lastname"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-9" }, [
                  _c(
                    "div",
                    { staticClass: "contact" },
                    [
                      _c("ValidationProvider", {
                        attrs: {
                          rules: {
                            required: _vm.required,
                            name: true,
                            maxlength: _vm.nameMaxLength
                          },
                          slim: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.item.lastName,
                                      expression: "item.lastName"
                                    }
                                  ],
                                  class: [
                                    "form-control",
                                    _vm.getValidationErrorClasses(errors)
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: _vm.title + "_lastname",
                                    "aria-labelledby": _vm.title + "_lastname",
                                    placeholder: _vm.lastNamePlaceholderString,
                                    readOnly: _vm.isReadOnly,
                                    disabled: _vm.isReadOnly,
                                    maxlength: _vm.nameMaxLength,
                                    "aria-required":
                                      _vm.required && !_vm.isReadOnly,
                                    "aria-invalid":
                                      _vm.required &&
                                      !_vm.isReadOnly &&
                                      errors.length > 0
                                  },
                                  domProps: { value: _vm.item.lastName },
                                  on: {
                                    focus: function($event) {
                                      return _vm.touch()
                                    },
                                    blur: function($event) {
                                      return _vm.onBlur()
                                    },
                                    change: function($event) {
                                      return _vm.change()
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.item,
                                        "lastName",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("email-row", {
              attrs: {
                title: "Organisation.Email",
                id: _vm.title + "_email",
                required: false,
                placeholder: _vm.$t("Organisation.Email"),
                maxLength: _vm.maxLength
              },
              model: {
                value: _vm.item.email,
                callback: function($$v) {
                  _vm.$set(_vm.item, "email", $$v)
                },
                expression: "item.email"
              }
            }),
            _vm._v(" "),
            _c("phone-row", {
              attrs: {
                title: "Organisation.Phone",
                id: _vm.title + "_phone",
                required: _vm.required,
                placeholder: _vm.$t("Organisation.Phone"),
                maxLength: 16
              },
              model: {
                value: _vm.item.phone,
                callback: function($$v) {
                  _vm.$set(_vm.item, "phone", $$v)
                },
                expression: "item.phone"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }